module.exports = __webpack_public_path__ + "static/media/taste-test-iphone-3.ccf1786c.png";